'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z' });

var OpenInBrowser = function OpenInBrowser(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

OpenInBrowser = (0, _pure2.default)(OpenInBrowser);
OpenInBrowser.muiName = 'SvgIcon';

exports.default = OpenInBrowser;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/OpenInBrowser.js
// module id = 2660
// module chunks = 0